export default __webpack_public_path__ + "static/media/crypto.5f73b4f1.png";